__turbopack_context__.v({
  "actions": "comments-module__56bzya__actions",
  "author": "comments-module__56bzya__author",
  "avatarColumn": "comments-module__56bzya__avatarColumn",
  "blocked": "comments-module__56bzya__blocked",
  "body": "comments-module__56bzya__body",
  "children": "comments-module__56bzya__children",
  "comment": "comments-module__56bzya__comment",
  "comments": "comments-module__56bzya__comments",
  "count": "comments-module__56bzya__count",
  "date": "comments-module__56bzya__date",
  "deleted": "comments-module__56bzya__deleted",
  "empty": "comments-module__56bzya__empty",
  "error": "comments-module__56bzya__error",
  "footer": "comments-module__56bzya__footer",
  "form": "comments-module__56bzya__form",
  "formButtons": "comments-module__56bzya__formButtons",
  "head": "comments-module__56bzya__head",
  "item": "comments-module__56bzya__item",
  "list": "comments-module__56bzya__list",
  "notice": "comments-module__56bzya__notice",
  "replyForm": "comments-module__56bzya__replyForm",
  "text": "comments-module__56bzya__text",
  "thread": "comments-module__56bzya__thread",
  "title": "comments-module__56bzya__title",
});
